import { calAgeToDate } from 'designer/component/action/Date'

const getRuleAgeToDateFieldKey = (field = {}) => {
  field = field || {}

  if (typeof field === 'string') return field

  return (
    field.optionValue ||
    field.actionOptionValue ||
    field.field ||
    field.valueKey ||
    field.key ||
    field.fieldKey ||
    field.name ||
    field.fieldName ||
    field.fieldPath ||
    field.target ||
    field.targetKey ||
    field.targetName ||
    field.targetOptionValue ||
    ''
  )
}

const getRuleAgeToDateAgeField = (action = {}) => {
  return {
    source: action.targetSource || 'formData',
    optionValue:
      action.target ||
      action.targetKey ||
      action.key ||
      action.valueKey ||
      action.targetName ||
      action.targetOptionValue ||
      '',
  }
}

const getRuleAgeToDateAgeValue = (
  designContext = {},
  action = {},
  data = {},
  getRuleValue = () => undefined,
) => {
  let field = getRuleAgeToDateAgeField(action)
  let fieldKey = getRuleAgeToDateFieldKey(field)
  if (!fieldKey) return undefined

  return getRuleValue(
    designContext,
    {
      source: field.source || 'formData',
      field: fieldKey,
    },
    data,
  )
}

const getRuleAgeToDateTarget = (action = {}) => {
  return getRuleAgeToDateFieldKey(action.ageToDate)
}

const isRuleAgeToDateAgeValid = (age) => {
  if (age === '' || age === undefined || age === null) return false
  return Number.isFinite(Number(age))
}

export const onRuleAgeToDate = (
  designContext = {},
  action = {},
  data = {},
  options = {},
) => {
  let {
    getRuleValue = () => undefined,
    setRuleFormData = () => undefined,
  } = options
  let target = getRuleAgeToDateTarget(action)
  let age = getRuleAgeToDateAgeValue(
    designContext,
    action,
    data,
    getRuleValue,
  )

  if (!target || !isRuleAgeToDateAgeValid(age)) return undefined

  let date = calAgeToDate(age)
  setRuleFormData(designContext, target, date)
  return date
}
